module.exports = __webpack_public_path__ + "assets/img/Light.e1818f87.svg";